<div class="mt-5 w-full px-4 py-4 sm:px-8">
  <h1
    class="mb-2 bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
    style="
      background: linear-gradient(
        to right,
        #008b79 0%,
        #008c6c 27%,
        #169999 60%,
        #004365 100%
      );
      background-clip: text;
    "
  >
    {{ 'pages.contact.title' | translate }}
  </h1>
</div>
